import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import Swal from "sweetalert2";
import { format } from "date-fns";

import "./style.css";
import { getRequest } from "utils/request";
import exportExcel from "utils/exportExcel";

import { deleteRequest } from "utils/request";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { i18n } from '../../translate/i18n';
import { useNotification } from "hooks/notification";
import { useAuth } from "hooks/auth";

import { useHistory } from 'react-router-dom'
import { useModal } from "hooks/modal";

export default function SkuteScheduling() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [onlyActive, setOnlyActive] = useState(true);
  const [update, setUpdate] = useState(0);
  const [globalFilter, setGlobalFilter] = useState('');
  const history = useHistory();
  const { toggleHelperId} = useModal();
  
  const { 
    selectedCompany, 
    addSelectedCompany,  
    updateHeaderSelectedTicket,
    listOptionsCompanies
  } = useNotification();
  

  const { user } = useAuth();

  useEffect(() => {

    // const user = localStorage.getItem("user-omni");
    // const CompleteUser = JSON.parse(user);
    setLoading(true);
    getRequest(`/events/agent?CompanyId=${selectedCompany.id}&AgentId=${user.id}&onlyActive=${onlyActive ? 1 : 0}`)
      .then(function (response) {
        response.data.forEach(e => {
          if(e.active === 1) {
            e.active = i18n.t('userActive');
          } else {
            e.active = i18n.t('inactive');
          }
        })
          setData(response.data);
          setLoading(false);
        }
    )
    toggleHelperId(20)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [update, selectedCompany.id, onlyActive]);


  const handleDelete = (id) => {
    Swal.fire({
      title: i18n.t('attemption'),
      text: i18n.t('deleteScheduling'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: i18n.t('confirmEraseCompany'),
    }).then((result) => {
      if (result.isConfirmed) {
      deleteRequest(`/events/agent/${id}`)
        .then(function (response) {
            setUpdate(update + 1);
          }
        )
      }
    });
  };

  const header = (
    <div className="data-table-header"
    >
      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'absolute', left: 0}}>
        <div className="checkbox-container" style={{marginRight: 30}}>
          <input checked={onlyActive} onChange={(e) => setOnlyActive(!onlyActive)} name="feedback" type="checkbox" className="checkbox" style={{marginRight: 10}}/>
          <label>{i18n.t('showInactive')}</label>
        </div>
      </div>
      <i className="pi pi-search" style={{paddingRight: 10}}></i>
      <input 
        className='input-globalfilter' 
        type="search" 
        onChange={(e) => setGlobalFilter(e.target.value)} 
        placeholder="Buscar" 
        icon="pi pi-search"/>
    </div>
  )

  const dateTemplate = (data) => {
    return ( 
      <span>
      {data.date && format(
        new Date(data.date),
        "dd/MM/yyyy"
      )}
    </span>
    )
  }

  const handleNavigation = (ticket) => {
    const skuteIndex = listOptionsCompanies.findIndex(e => e.value === Number(process.env.REACT_APP_SKUTE_ID));
    if(skuteIndex >= 0) {
      if(selectedCompany.id !== ticket.companyId) {
        addSelectedCompany({
          value: listOptionsCompanies[skuteIndex].value,
          id: listOptionsCompanies[skuteIndex].value,
          label: listOptionsCompanies[skuteIndex].label,
          logo: listOptionsCompanies[skuteIndex].pathLogo,
          trial: listOptionsCompanies[skuteIndex].trial,
          trialLimit: listOptionsCompanies[skuteIndex].trialValidate,
          usersLimit: listOptionsCompanies[skuteIndex].usersLimit,
          dueDay:  listOptionsCompanies[skuteIndex].dueDay,
          ticketToShow: listOptionsCompanies[skuteIndex].ticketToShow,

        })
      }
      history.push(`../../../../../dashboard/chat/`);
      updateHeaderSelectedTicket(ticket.TicketId, ticket.ticket);
    }    
  }

  const protocolTemplate = (data) => {
    return (
      <div className="ticket-link" onClick={() => handleNavigation(data)}>
        {data.ticket}
      </div>
    )
  }

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{display: "flex", flexDirection: "row"}}>
        <div
          className="action-icon"
          style={{ cursor: "pointer" }}
          onClick={() => handleDelete(data.id)}
        >
          <i className="mdi mdi-delete" style={{fontSize: 20}}></i>
        </div>
      </div>
    )
  }

  const handleExport = () => {
    let scheduleData = [];

    data.forEach(e => {
      const schedule = {
        Id: e.id,
        [i18n.t('company')]: e.company,
        [i18n.t('event')]: e.event,
        TicketId: e.TicketId,
        Ticket: e.ticket,
        Cliente: e.name,
        [i18n.t('date')]: format(new Date(e.date), 'dd/MM/yyyy'),
        [i18n.t('agent')]: e.nickName

      }
      scheduleData.push(schedule);
    })

    exportExcel(scheduleData, i18n.t('scheduling') + 's SKUTE')
  }

  return (
    <>
      <div className="col-12" style={{ overflowY: "auto" }}>
        <div className="card">
          <div className="card-body">
            <div className="area-header-table-users">
              <h4>{i18n.t('scheduling') + 's'} SKUTE</h4>
                <button type="button" onClick={handleExport} className="export-excel" >
                  <i style={{fontSize: 16, marginRight: 5}}className="pi pi-file-excel"/>  
                  <span style={{fontSize: '1vw'}}>{i18n.t('exportAllData')}</span>
                </button>
            </div>
                <div className="tab-content">
                  <div className="tab-pane show active" id="multi-item-preview">
                    {!loading ? (
                       <DataTable 
                       header={header}
                       globalFilter={globalFilter}
                       dataKey="id"
                       rowsPerPageOptions={[25,50,100]}  
                       value={data}
                       paginator
                       rows={25} 
                       emptyMessage={i18n.t('noSchedulingFound')}
                     >
                         <Column field="company" header={i18n.t('company')} sortable></Column>
                         <Column field="event" header={i18n.t('description')}></Column>
                         <Column body={protocolTemplate} filterField='ticket' header={i18n.t('protocol')} ></Column>
                         <Column field="name" header={i18n.t('user')}></Column>
                         <Column field="active" header={i18n.t('status')}></Column>
                         <Column body={dateTemplate} filterField='date' header={i18n.t('date')}></Column>
                         <Column body={actionButtonsTemplate} header={i18n.t('action')}></Column>
                     </DataTable>
                    ) : (
                      <div className="area-loading">
                        <CircularProgress />
                      </div>
                    )}
                  </div>
                </div>
          </div>
        </div>
      </div>
    </>
  );
}
